import configs from '@/configs';
import {request_header, request_list} from '@/commons/hpod';
import { sendErrorNotice } from '@/commons/utils';

export default {
    getPayOrderList(cb, $http, param, token) {
        request_list('pay_order', cb, $http, param, token)
    },
    getPayOrderDetail(cb, $http, customerId, token) {
        const req = {
            headers: request_header(token)
        };
        $http.get(`${configs.API}/admin/api/pay_order/${customerId}`, req).then(function (res) {
            setTimeout(() => cb(res.data), 100);
        });
    },
    updatePayOrder(cb, $http, {order_ids, deposit_ids, cash, method, totalPayLeft, shipFee, feeOther, feeOtherName, customer_id}, token) {
        const header = {
            headers: request_header(token)
        };
        let req = _.cloneDeep({order_ids: order_ids.join(','), deposit_ids: deposit_ids.join(','), cash, method, totalPayLeft, shipFee, feeOther, feeOtherName, customer_id});
        $http.post(`${configs.API}/admin/api/pay_order/${customer_id}`, req, header).then(function (res) {
            setTimeout(() => cb(res.data), 100);
        },
        function (err) {
            if(err.status == 401) {
                window.getApp.$emit("APP_AUTH_FAILED");
            }
            else if(err.status == 406) {
                sendErrorNotice(err.data.reason);
            }
        });
    }
}
